import { TeacherHomePage } from "@/pages/teacher/TeacherHomePage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/teacher/")({
  component: TeacherHomePage,
});
